const ResetButton = ({ resetHandler }) => {
  return (
    <button className="btn" onClick={resetHandler}>
      {" "}
      Neue Runde{" "}
    </button>
  );
};

export default ResetButton;
